import { Observable } from "rxjs";

import { ArgumentNullError } from "@gp/utility";

import { ISportStatisticsSubscriptionRequest, ISportStatisticsSubscriptionResponse, IConnection } from "../../common";
import { Hub } from "../../Hub";
import { SportStatisticsHubOptions } from "./SportStatisticsHubOptions";

/**
 * SportStatisticsHub is used for pressure index updates
 */
export class SportStatisticsHub extends Hub {
	/**
	 * Creates an instance of SportStatistics Hub
	 * @param options
	 * @param connection 
	 */
	constructor(options: SportStatisticsHubOptions, connection: IConnection) {
		super(options, connection);
	}

	/**
	 * Get changes for event pressure index
	 * @param request subscription request filter
	 * @returns observable that is updated every time new message arrives on the hub
	 */
	getSubscription(request: ISportStatisticsSubscriptionRequest): Observable<ISportStatisticsSubscriptionResponse[]> {
		if (request == null) {
			throw new ArgumentNullError('request');
		}

		return this.createSubscription<ISportStatisticsSubscriptionResponse[]>(request.subscriptionId, () => {
			return this.invoke('Subscribe', request);
		}, () => this.invoke('Unsubscribe', { subscriptionId: request.subscriptionId }));
	}
}